/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { transactionCountListChainKeyTransactionCountApiV2TransactionCountGet } from "../../funcs/transactionCountListChainKeyTransactionCountApiV2TransactionCountGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .ListChainKeyTransactionCountApiV2TransactionCountGetRequest$inboundSchema
    .optional(),
};

export const tool$transactionCountListChainKeyTransactionCountApiV2TransactionCountGet:
  ToolDefinition<typeof args> = {
    name: "chain-key-tx-count-v2",
    description: `Original tool name: transaction-count-list-chain-key-transaction-count-api-v2-transaction-count-get

List aggregated transaction count`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await transactionCountListChainKeyTransactionCountApiV2TransactionCountGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };